import React, { useEffect, useState } from "react";

import {
  Box,
  IconButton,
  makeStyles,
  Typography,
  useTheme,
} from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import DataService from "../../../../Service";
import CustomInput from "../../../../Components/CustomInput";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Grid from "@material-ui/core/Grid";
import { Divider } from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import DataClient from "../../../../Service/general_data_service";

const BORDER = "1px solid #70707040";

function SupplierInvoicingDetails() {
  const classes = useStyles();

  const theme = useTheme();

  const [clientInvoicingBasics, setClientInvoicingBasics] = useState([]);
  const [clientInvoicingSchedule, setClientInvoicingSchedule] = useState([]);
  const [addOnsBillingSchedule, setAddOnsBillingSchedule] = useState([]);
  const [clientBillingSchedules, setClientBillingSchedules] = useState([]);
  const [sepecifiedelemetPrice, setSpecifiedelemetPrice] = useState("");
  const [numOfTranche, setNumofTranche] = useState("");
  const [poNumberValue, setPoNumberValue] = useState(" ");
  const [addOnsNumofTranche, setAddOnsNumofTranche] = useState("");
  const [loading, setLoading] = useState(false);
  const [supplierInvoicingDetail, setSupplierInvoicingDetail] = useState([]);
  const [moduleData, setModuleData] = useState([]);
  const [open, setOpen] = useState(false);

  let urlElements = window.location.href.split("/");
  const InvoiceID = `${urlElements[5]}`;
  const getData = () => {
    const params = {
      invoice_id: InvoiceID,
    };
    DataService.getDirectData(`/invoices/supplier_invoicing_details`, params)
      .then((response) => {
        setClientInvoicingBasics(response.client_invoicing_basics);
        setClientInvoicingSchedule(response.client_invoicing_schedule);
        setAddOnsNumofTranche(
          response.add_ons_invoicing_schedule.num_of_tranche
        );
        setAddOnsBillingSchedule(
          response.add_ons_invoicing_schedule.add_ons_billing_schedules
        );
        setClientBillingSchedules(
          response.client_invoicing_schedule.client_billing_schedules
        );
        setSupplierInvoicingDetail(response.client_invoicing_detail);
        setSpecifiedelemetPrice(response.specified_element_price);
        setPoNumberValue(response.PO_number ? response.PO_number : " ");
        setNumofTranche(response.client_invoicing_schedule.num_of_tranche);
        setLoading(false);
      })

      .catch((err) => {});
  };
  useEffect(() => {
    setLoading(true);
    getData();
  }, []);
  const setInputState = (inputStateValue, inputId) => {
    setModuleData({ ...moduleData, [inputId]: inputStateValue });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    handleUpdate(formData);
  };
  const handleUpdate = (formData) => {
    setLoading(true);
    // DataClient.update({ ...moduleData }, "edit_po_number")
    const statusData = {
      invoice_id: InvoiceID,
      ...moduleData,
    };
    DataClient.update(statusData, `/invoices/edit_po_number`)
      .then((res) => {
        if (res.success) {
          handleClose();
          getData();
        } else {
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const PoCapitaliser = (inp) => {
    if (inp?.toLowerCase().includes("po")) {
      const separated = inp?.toLowerCase().split(" ");
      console.log(separated, inp, "input");
      return separated
        ?.map((el) => {
          if (el === "po") {
            return "PO";
          } else {
            return el;
          }
        })
        .join(" ");
    } else {
      return inp;
    }
  };
  return (
    <div style={{ width: "100%" }}>
      <Box pb="16px" borderBottom={BORDER}>
        <Typography
          variant="body1"
          style={{ marginBottom: "14px" }}
          className={classes.heading}
        >
          Supplier invoicing basics
        </Typography>

        {clientInvoicingBasics.length > 0 &&
          clientInvoicingBasics.map((item) => (
            <Typography key={item} variant="body1" className={classes.body}>
              {item.toLowerCase().includes("po") ? PoCapitaliser(item) : item}
            </Typography>
          ))}
      </Box>

      <Box
        width="100%"
        display="flex"
        mt="20px"
        pb="25px"
        borderBottom={BORDER}
      >
        <Box width="40%">
          <Typography
            variant="body1"
            style={{ marginBottom: "20px" }}
            className={classes.heading}
          >
            Supplier invoicing schedule
          </Typography>
          <Typography variant="body1" className={classes.body}>
            Tranche - <b>{numOfTranche}</b>
          </Typography>
        </Box>

        <Box width="60%">
          <Typography
            variant="body1"
            style={{ marginBottom: "20px" }}
            className={classes.heading}
          >
            Supplier billing schedule
          </Typography>
          {clientBillingSchedules.length > 0 &&
            clientBillingSchedules.map((item) => (
              <Typography key={item} variant="body1" className={classes.body}>
                {item.percentage} - {item.installment_type}
              </Typography>
            ))}
        </Box>
      </Box>

      <Box
        width="100%"
        display="flex"
        mt="20px"
        pb="25px"
        borderBottom={BORDER}
      >
        <Box width="40%">
          <Typography
            variant="body1"
            style={{ marginBottom: "20px" }}
            className={classes.heading}
          >
            Add-ons invoicing schedule
          </Typography>
          <Typography variant="body1" className={classes.body}>
            Tranche - <b>{addOnsNumofTranche}</b>
          </Typography>
        </Box>

        <Box width="60%">
          <Typography
            variant="body1"
            style={{ marginBottom: "20px" }}
            className={classes.heading}
          >
            Add-ons billing schedule
          </Typography>
          {addOnsBillingSchedule.length > 0 &&
            addOnsBillingSchedule.map((item) => (
              <Typography key={item} variant="body1" className={classes.body}>
                {item.percentage} - {item.installment_type}
              </Typography>
            ))}
        </Box>
      </Box>
      <Box width="100%" mt="20px">
        <Typography
          variant="body1"
          style={{ marginBottom: "20px" }}
          className={classes.heading}
        >
          Supplier invoicing details
        </Typography>
        <Box width="100%" display="flex" mb="45px">
          <Box width="20%">
            <Typography
              variant="body1"
              className={classes.body}
              style={{ color: "#077f83" }}
            >
              Name
            </Typography>
            <Typography variant="body1" className={classes.body}>
              {supplierInvoicingDetail.name}
            </Typography>
          </Box>
          <Box width="30%">
            <Typography
              variant="body1"
              className={classes.body}
              style={{ color: "#077f83" }}
            >
              Invoice address
            </Typography>
            <Typography variant="body1" className={classes.body}>
              {supplierInvoicingDetail.invoice_address}
            </Typography>
          </Box>
          <Box width="25%">
            <Typography
              variant="body1"
              className={classes.body}
              style={{ color: "#077f83" }}
            >
              Email
            </Typography>
            <Typography variant="body1" className={classes.body}>
              {supplierInvoicingDetail.email}
            </Typography>
          </Box>
          <Box width="20%">
            <Typography
              variant="body1"
              className={classes.body}
              style={{ color: "#077f83" }}
            >
              Invoice narrative
            </Typography>
            <Typography variant="body1" className={classes.body}>
              {supplierInvoicingDetail.invoice_narrative}
            </Typography>
          </Box>
        </Box>
        {
          <Box>
            <Typography
              variant="body1"
              style={{ marginBottom: "20px" }}
              className={classes.heading}
            >
              PO number
            </Typography>
            <Box display="flex" alignItems="center">
              <Typography
                variant="body1"
                style={{ marginRight: "60px", marginBottom: 0 }}
                className={classes.body}
              >
                {poNumberValue}
              </Typography>
              <IconButton onClick={handleClickOpen} edge="start">
                <Edit />
              </IconButton>
            </Box>
          </Box>
        }
      </Box>
      <Dialog
        maxWidth={"sm"}
        style={{ height: "70%" }}
        open={open}
        onClose={handleClose}
        aria-labelledby="base-station-manage"
      >
        <DialogTitle id="customized-dialog-title">
          <IconButton
            className={classes.iconButton}
            onClick={handleClose}
            aria-label="menu"
          >
            <ArrowBackIcon />
          </IconButton>
          Update PO number
        </DialogTitle>
        <Divider />
        <DialogContent style={{ margin: "0px auto" }}>
          <div className={classes.formWrapper}>
            <Typography
              variant="subtitle2"
              color="secondary"
              className={classes.title}
            ></Typography>
            <form onSubmit={handleSubmit}>
              <Grid
                container
                spacing={1}
                alignItems={"center"}
                justify={"flex-start"}
              >
                <React.Fragment>
                  <Grid item xs={12}>
                    <Typography
                      variant="subtitle2"
                      color="secondary"
                      className={classes.title}
                    >
                      PO number
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <CustomInput
                      id="po_number_value"
                      parentcall={setInputState}
                      required
                      variant="outlined"
                      style={{ backgroundColor: "#fff" }}
                      defaultValue={poNumberValue}
                      placeholder="PO number"
                    />
                  </Grid>
                </React.Fragment>
              </Grid>

              <div className={classes.actionButtons}>
                <Button
                  disableElevation
                  disabled={loading}
                  type="button"
                  variant={"contained"}
                  onClick={handleClose}
                  style={{ textTransform: "none" }}
                >
                  Cancel
                </Button>
                <Button
                  disableElevation
                  disabled={loading}
                  type="submit"
                  variant={"contained"}
                  color="secondary"
                  style={{ textTransform: "none" }}
                >
                  {"Update"}
                </Button>
              </div>
            </form>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default SupplierInvoicingDetails;

const useStyles = makeStyles((theme) => ({
  heading: {
    fontSize: 14,
    lineHeight: "24px",
    fontWeight: "bold",
    color: theme.palette.secondary.main,
  },

  body: {
    fontSize: 14,
    lineHeight: "24px",
    marginBottom: 14,
    color: "#232323",
  },
  formWrapper: {
    background: "#fff",
    width: "400px",
    padding: theme.spacing(3),
  },
  title: {
    textTransform: "none",
  },
  actionButtons: {
    paddingTop: "35px",
    textAlign: "center",
    "& button": {
      marginRight: "20px",
    },
  },
}));
